<p-dialog
  [closable]="false"
  (onClose)="dismiss()"
  [draggable]="false"
  [modal]="true"
  (onHide)="dismiss()"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [resizable]="false"
  [visible]="true"
>
  <ng-template #header>
    <header>
      <h4>Please confirm</h4>
    </header>
    <a
      role="button"
      tabindex="0"
      aria-hidden="true"
      (click)="dismiss()"
      class="p-dialog-titlebar-icon ui-dialog-titlebar-close"
    >
      <span class="pi pi-times"></span>
    </a>
  </ng-template>
  <header class="confirm-dialog">
    <p [innerHTML]="message"></p>
    @if (showDeleteInput) {
      <div>
        Please confirm by typing "delete":
        <input
          pInputText
          type="text"
          [(ngModel)]="deleteText"
          class="form-control"
        />
      </div>
    }
    <div class="p-dialog-buttonpane ui-helper-clearfix">
      <button
        pButton
        class="w-md"
        [severity]="destructive ? 'danger' : 'primary'"
        data-cy="confirm-yes"
        #confirmButton
        [disabled]="showDeleteInput && deleteText !== 'delete'"
        (click)="close()"
      >
        {{ confirmLabel ?? (destructive ? "Delete" : "Yes") }}
      </button>
      <button
        pButton
        class="w-md"
        severity="secondary"
        data-cy="confirm-no"
        #denyButton
        (click)="dismiss()"
      >
        {{ denyLabel ?? (destructive ? "Cancel" : "No") }}
      </button>
    </div>
  </header>
</p-dialog>
